<template>
  <StandardTemplate class="lg:max-w-5xl">
    <div class="heading flex-col lg:flex-row justify-between">
      <div class="flex">
        <h2>Billing History</h2>
      </div>
    </div>
    <div class="lg:flex">
      <div class="container-blue">
        <BaseTable
          title="STATEMENTS"
          searchPlaceholder="Search Statements"
          :colDef="colDef"
          :data="tableData"
          :showLoading="loading"
          :callToAction="callToAction"
          :pagination="pagination"
          showSearch
          @row-action-click="actionClick"
        />
      </div>
    </div>
  </StandardTemplate>
</template>
<script src="./BillingHistory.js"></script>

